import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/config";
import { useCompare, MAX_COMPARE } from "@/lib/compare";
import { X, GitCompareArrows } from "lucide-react";

export default function CompareBar() {
  const { slugs, remove, clear } = useCompare();
  const [tours, setTours] = useState([]);
  const loc = useLocation();

  useEffect(() => {
    if (slugs.length === 0) { setTours([]); return; }
    Promise.all(slugs.map((s) => api.get(`/tours/${s}`).then((r) => r.data).catch(() => null)))
      .then((list) => setTours(list.filter(Boolean)));
  }, [slugs.join(",")]); // eslint-disable-line

  useEffect(() => {
    if (slugs.length === 0 || loc.pathname === "/compare") return;
    document.body.style.paddingBottom = "76px";
    return () => { document.body.style.paddingBottom = ""; };
  }, [slugs.length, loc.pathname]);

  if (slugs.length === 0 || loc.pathname === "/compare") return null;

  return (
    <div
      data-testid="compare-bar"
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#1F150E] text-[#FAF6F0] shadow-[0_-8px_30px_rgba(26,18,8,0.25)]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-3 pr-24 md:pr-56 flex items-center gap-4">
        <span className="hidden sm:inline text-[11px] uppercase tracking-[0.22em] text-[#C88B35] flex-shrink-0">
          Comparing
        </span>

        <div className="flex items-center gap-3 flex-1 min-w-0">
          {tours.map((t) => (
            <div key={t.slug} data-testid={`compare-chip-${t.slug}`} className="flex items-center gap-2 bg-[#FAF6F0]/10 rounded-full pl-1.5 pr-3 py-1.5 min-w-0">
              <img src={t.hero_image} alt="" className="w-8 h-8 rounded-full object-cover flex-shrink-0" />
              <span className="text-xs truncate max-w-[110px] md:max-w-[220px]">{t.title}</span>
              <button
                data-testid={`compare-remove-${t.slug}`}
                onClick={() => remove(t.slug)}
                className="text-[#FAF6F0]/60 hover:text-[#FAF6F0] flex-shrink-0"
                aria-label={`Remove ${t.title}`}
              >
                <X size={13} />
              </button>
            </div>
          ))}
          {slugs.length < MAX_COMPARE && (
            <span className="text-xs text-[#FAF6F0]/50 hidden sm:inline">Pin one more to compare</span>
          )}
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          <button data-testid="compare-clear" onClick={clear} className="text-xs text-[#FAF6F0]/55 hover:text-[#FAF6F0] hidden sm:inline">
            Clear
          </button>
          <Link
            to="/compare"
            data-testid="compare-open"
            className={`btn-pill text-xs ${slugs.length < 2 ? "pointer-events-none opacity-45 bg-[#FAF6F0]/15 text-[#FAF6F0]" : "btn-pill-primary"}`}
          >
            <GitCompareArrows size={14} /> Compare
          </Link>
        </div>
      </div>
    </div>
  );
}
